import React from 'react';
import PropTypes from 'prop-types';
import {
  FDHeadlineText,
  FDPaper,
  FDBodyText,
  FDStack, FDBox,
} from '@facet-wealth/design';

import TransitionsDashboardPageMeetingTranscript from './TransitionsDashboardPageMeetingTranscript';

const TransitionsDashboardPageMeetingTranscripts = ({ collection }) => {
  const [currentStep, setCurrentStep] = React.useState(0);
  const stepsCount = collection.resources().length();

  if (stepsCount === 0) {
    return (
      <FDPaper appearance={'elevated'} margin={300} padding={500} minWidth={'500px'} flex={1}>
        <FDHeadlineText value={'Meeting Transcripts'} color={'textSecondary'} />
        <FDBox paddingY={3}>
          <FDStack direction="row" alignItems={'center'} justifyContent={'center'} spacing={1} wrap>
            <FDBodyText value={'No meeting transcripts available'} />
          </FDStack>
        </FDBox>
      </FDPaper>
    );
  }

  return (
    <FDPaper appearance={'elevated'} margin={300} padding={500} minWidth={'500px'} flex={1}>
      <FDHeadlineText value={'Meeting Transcripts'} color={'textSecondary'} />
      <TransitionsDashboardPageMeetingTranscript
        resource={collection.resources().list()[currentStep]}
        currentStep={currentStep}
        stepsCount={stepsCount}
        setCurrentStep={setCurrentStep}
      />
    </FDPaper>
  );
};

TransitionsDashboardPageMeetingTranscripts.propTypes = {
  collection: PropTypes.object.isRequired,
};

TransitionsDashboardPageMeetingTranscripts.defaultProps = {};

export default TransitionsDashboardPageMeetingTranscripts;
